export default __webpack_public_path__ + "static/media/image90.bf1f146b.svg";